import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';

@Injectable()
export class DriverService {
  driverList : AngularFireList<any>;
  constructor(private firebase : AngularFireDatabase) { }
getData()
{
  this.driverList = this.firebase.list('users');
  return this.driverList;
}
getSupervisors()
{
  this.driverList = this.firebase.list('users', ref=> ref.orderByChild("role").equalTo("supervisor"));
  return this.driverList;
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/drivers/shared/driver.service.ts